document.addEventListener('DOMContentLoaded', () => {
  initHeroSlider();
  initProductCarousel();
  initMobileMenu();
});

function initHeroSlider() {
  document.querySelectorAll('[data-woofy-hero]').forEach((hero) => {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    const prevBtn = hero.querySelector('[data-hero-prev]');
    const nextBtn = hero.querySelector('[data-hero-next]');
    if (!slides.length) return;

    let current = 0;
    let autoplay = hero.dataset.autoplay === 'true';
    let interval = parseInt(hero.dataset.interval || '5000', 10);
    let timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    prevBtn?.addEventListener('click', () => { prev(); resetAutoplay(); });
    nextBtn?.addEventListener('click', () => { next(); resetAutoplay(); });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { goTo(i); resetAutoplay(); });
    });

    function resetAutoplay() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    if (autoplay) timer = setInterval(next, interval);
  });
}

function initProductCarousel() {
  document.querySelectorAll('[data-woofy-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    const cards = track.querySelectorAll('.woofy-product-card');
    let offset = 0;

    function getVisibleCount() {
      if (window.innerWidth <= 480) return 1;
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 1024) return 3;
      return 4;
    }

    function getCardWidth() {
      const card = cards[0];
      if (!card) return 0;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      const maxOffset = Math.max(0, cards.length - getVisibleCount());
      if (prevBtn) prevBtn.disabled = offset <= 0;
      if (nextBtn) nextBtn.disabled = offset >= maxOffset;
    }

    function slide(direction) {
      const maxOffset = Math.max(0, cards.length - getVisibleCount());
      offset = Math.max(0, Math.min(maxOffset, offset + direction));
      track.style.transform = `translateX(-${offset * getCardWidth()}px)`;
      updateButtons();
    }

    prevBtn?.addEventListener('click', () => slide(-1));
    nextBtn?.addEventListener('click', () => slide(1));
    window.addEventListener('resize', () => {
      offset = 0;
      track.style.transform = 'translateX(0)';
      updateButtons();
    });
    updateButtons();
  });
}

function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
}
